`use strict`;

class Draad_Dialog {

    constructor(node) {

        this._dialog = node;
        this._controls = document.querySelectorAll('[aria-controls="' + node.id + '"]');

        this._handlers();

    }

    _handlers() {

        for (const control of this._controls) {

            control.addEventListener('click', () => {

                if (control.attributes['data-dialog-action'].value == 'open') {

                    this._open();

                } else if (control.attributes['data-dialog-action'].value == 'close') {

                    this._close();

                }

            });

        }

        this._dialog.addEventListener('click', (e) => {

            // Close dialog when clicking on overlay
            if (e.target == this._dialog) {

                this._close();

            }

        });

    }

    _open() {

        this._dialog.showModal();

        for (const control of this._controls) {

            control.setAttribute('aria-expanded', 'true');

        }

    }

    _close() {

        this._dialog.close();

        for (const control of this._controls) {

            control.setAttribute('aria-expanded', 'false');

        }

    }

};

(function () {

    const dialogs = document.querySelectorAll('.dialog');
    if (dialogs) {

        for (const dialog of dialogs) {

            const test = new Draad_Dialog(dialog);

        }

    }

})();